module.exports = __webpack_public_path__ + "img/img_ticket_premium_class.0bfc1d85.png";